import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/illustration1.png'
import _imports_1 from '@/assets/images/step1.png'
import _imports_2 from '@/assets/images/step3.png'
import _imports_3 from '@/assets/images/icon-copy.png'
import _imports_4 from '../../assets/images/bg-gery.png'


_pushScopeId("data-v-1f9646b0")
const _hoisted_1 = { class: "klickl-pay-cashier" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "ctx" }
const _hoisted_4 = { class: "brand" }
const _hoisted_5 = { class: "name font-bold" }
const _hoisted_6 = { class: "lang" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "slogan animated fadeInLeft" }
const _hoisted_10 = { class: "title font-bold" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "illustration" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  draggable: "false"
}, null, -1)
const _hoisted_14 = { class: "desc" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "order" }
const _hoisted_17 = { class: "head" }
const _hoisted_18 = { class: "title font-bold" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_20 = { class: "body" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-1f9646b0><div class=\"project\" data-v-1f9646b0><div class=\"list\" data-v-1f9646b0><div class=\"item active\" data-v-1f9646b0><div class=\"info\" data-v-1f9646b0><div class=\"icon\" data-v-1f9646b0><img src=\"/images/icon-logo.png\" alt=\"Klickl Pay\" data-v-1f9646b0></div><div class=\"value\" data-v-1f9646b0><div class=\"name\" data-v-1f9646b0>Klickl Pay</div></div></div></div></div></div></div>", 1)
const _hoisted_22 = { class: "container" }
const _hoisted_23 = {
  key: 0,
  class: "project"
}
const _hoisted_24 = { class: "title" }
const _hoisted_25 = { class: "list" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "info" }
const _hoisted_28 = { class: "icon" }
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "name" }
const _hoisted_32 = {
  key: 1,
  class: "project"
}
const _hoisted_33 = { class: "title" }
const _hoisted_34 = { class: "list" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "info" }
const _hoisted_37 = { class: "icon" }
const _hoisted_38 = ["src", "alt"]
const _hoisted_39 = { class: "value" }
const _hoisted_40 = { class: "name" }
const _hoisted_41 = {
  key: 0,
  class: "desc"
}
const _hoisted_42 = { class: "extend" }
const _hoisted_43 = {
  key: 0,
  class: "footer"
}
const _hoisted_44 = { class: "total" }
const _hoisted_45 = {
  key: 0,
  class: "item"
}
const _hoisted_46 = { class: "value" }
const _hoisted_47 = { class: "item" }
const _hoisted_48 = { class: "number font-bold" }
const _hoisted_49 = { class: "action font-bold" }
const _hoisted_50 = { class: "pay" }
const _hoisted_51 = { class: "head" }
const _hoisted_52 = { class: "title font-bold" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_54 = { class: "desc" }
const _hoisted_55 = { class: "body" }
const _hoisted_56 = { class: "container" }
const _hoisted_57 = {
  key: 0,
  class: "form"
}
const _hoisted_58 = {
  key: 0,
  class: "item full"
}
const _hoisted_59 = { class: "label" }
const _hoisted_60 = { class: "value" }
const _hoisted_61 = {
  key: 1,
  class: "item full"
}
const _hoisted_62 = { class: "label" }
const _hoisted_63 = { class: "value" }
const _hoisted_64 = {
  key: 2,
  class: "item full"
}
const _hoisted_65 = { class: "label" }
const _hoisted_66 = { class: "value" }
const _hoisted_67 = { class: "search" }
const _hoisted_68 = { class: "input" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 3,
  class: "item full"
}
const _hoisted_71 = { class: "label" }
const _hoisted_72 = { class: "value" }
const _hoisted_73 = {
  key: 4,
  class: "item full"
}
const _hoisted_74 = { class: "label" }
const _hoisted_75 = { class: "value" }
const _hoisted_76 = { class: "footer" }
const _hoisted_77 = { class: "action font-bold" }
const _hoisted_78 = {
  key: 1,
  class: "status"
}
const _hoisted_79 = {
  key: 0,
  class: "loader"
}
const _hoisted_80 = { class: "icon" }
const _hoisted_81 = ["src", "alt"]
const _hoisted_82 = { class: "name" }
const _hoisted_83 = { class: "amount" }
const _hoisted_84 = { class: "infos" }
const _hoisted_85 = { class: "label" }
const _hoisted_86 = { class: "value" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { class: "label" }
const _hoisted_91 = { class: "value" }
const _hoisted_92 = {
  key: 0,
  class: "channel"
}
const _hoisted_93 = ["src", "alt"]
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { class: "label" }
const _hoisted_96 = { class: "value" }
const _hoisted_97 = { key: 2 }
const _hoisted_98 = { class: "label" }
const _hoisted_99 = { class: "value" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = { key: 3 }
const _hoisted_103 = { class: "value full" }
const _hoisted_104 = {
  key: 4,
  class: "line"
}
const _hoisted_105 = { key: 5 }
const _hoisted_106 = { class: "label" }
const _hoisted_107 = { class: "value" }
const _hoisted_108 = { class: "item" }
const _hoisted_109 = { class: "label" }
const _hoisted_110 = { class: "value" }
const _hoisted_111 = { class: "copyright" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:business@klicklpay.com" }, "business@klicklpay.com", -1)
const _hoisted_113 = {
  key: 0,
  class: "background"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "background"
}, null, -1)
const _hoisted_115 = [
  _hoisted_114
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_VueQrcode = _resolveComponent("VueQrcode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("cashier.h1")), 1)
        ]),
        _createVNode(_component_van_popover, {
          show: _ctx.showPopover,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPopover = $event)),
          actions: _ctx.data.Languages,
          theme: "dark",
          onSelect: _ctx.changeLang
        }, {
          reference: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("img", {
                src: `/images/${_ctx.locale}.png`,
                alt: _ctx.locale
              }, null, 8, _hoisted_7),
              _createTextVNode(_toDisplayString(_ctx.getLangName), 1)
            ])
          ]),
          _: 1
        }, 8, ["show", "actions", "onSelect"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_i18n_t, {
            keypath: "cashier.payout",
            scope: "global"
          }, {
            br: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_i18n_t, {
              keypath: "cashier.tip1",
              scope: "global"
            }, {
              br: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["payment", { ordered: _ctx.data.FormData.orderStatus !== 0 }])
      }, [
        (_ctx.data.FormData.orderStatus == 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["infos", { nexts: _ctx.step > 1 }])
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("cashier.paytype")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("div", _hoisted_22, [
                    (_ctx.CashChannelList?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("cashier.payment")), 1),
                          _createElementVNode("div", _hoisted_25, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CashChannelList, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["item", { active: item.code == _ctx.data.FormData.channelCode }]),
                                key: item.code,
                                onClick: 
                        () => {
                          _ctx.data.FormData.channelCode = item.code;
                        }
                      
                              }, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("img", {
                                      src: item.icon,
                                      alt: item.code
                                    }, null, 8, _hoisted_29)
                                  ]),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, _toDisplayString(item.name), 1)
                                  ])
                                ])
                              ], 10, _hoisted_26))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.PaymentTypeList?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("cashier.paytype")), 1),
                          _createElementVNode("div", _hoisted_34, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PaymentTypeList, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["item", { active: _ctx.data.FormData.paymentType == item.supportedChannelType }]),
                                key: item.id,
                                onClick: 
                        () => {
                          _ctx.data.FormData.paymentType = item.supportedChannelType;
                          _ctx.data.FormData.transactionFee = item.transactionFee;
                        }
                      
                              }, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("img", {
                                      src: 
                              _ctx.data.InterfaceUI[item.supportedChannelType]?.icon ||
                                '~@/assets/images/icon-other.png'
                            ,
                                      alt: item.supportedChannelType
                                    }, null, 8, _hoisted_38)
                                  ]),
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, _toDisplayString(item.supportedChannelType), 1),
                                    false
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.data.InterfaceUI[item.supportedChannelType]?.name ||
                                _ctx.$t("cashier.other")), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("cashier.fee")) + ": " + _toDisplayString(item.transactionFee), 1)
                              ], 10, _hoisted_35))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, false]
                  ]),
                  (_ctx.CashChannelList?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          false
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.fee")), 1),
                                _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.data.FormData.transactionFee) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.total")), 1),
                            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          (_ctx.data.FormData.cancelUrl)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "btn cancel",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paymentUrl(_ctx.data.FormData.cancelUrl, 'CANCEL')))
                              }, _toDisplayString(_ctx.$t("cashier.cancel")), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: "btn next",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextStep(true)))
                          }, _toDisplayString(_ctx.step == _ctx.steps.length ? _ctx.$t("cashier.pay") : _ctx.$t("cashier.next")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("cashier.scan")) + " " + _toDisplayString(_ctx.$t("cashier.payinfo")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t("cashier.desc")), 1)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    (!_ctx.result)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          (_ctx.forms.supplier)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t("cashier.supplier")), 1),
                                _createElementVNode("div", _hoisted_60, [
                                  _createVNode(_component_van_cell, {
                                    "is-link": "",
                                    icon: "birthday-cake-o",
                                    title: 
                            _ctx.getNameByCode(_ctx.data.FormData.supplier, _ctx.SupplierList) || _ctx.$t('choose')
                          ,
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSupplierSheet = true))
                                  }, null, 8, ["title"]),
                                  _createVNode(_component_van_action_sheet, {
                                    show: _ctx.showSupplierSheet,
                                    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSupplierSheet = $event)),
                                    actions: _ctx.SupplierList,
                                    onSelect: _ctx.onSelectSupplier,
                                    description: _ctx.$t('choose'),
                                    "cancel-text": _ctx.$t('cancel'),
                                    "close-on-click-action": ""
                                  }, null, 8, ["show", "actions", "onSelect", "description", "cancel-text"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.forms.phoneNumber)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t("cashier.phone")), 1),
                                _createElementVNode("div", _hoisted_63, [
                                  _createVNode(_component_van_field, {
                                    label: ``,
                                    placeholder: _ctx.$t('cashier.phone'),
                                    modelValue: _ctx.data.FormData.phoneNumber,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.data.FormData.phoneNumber = $event)),
                                    "left-icon": "phone-o",
                                    "right-icon": _ctx.data.FormData.phoneNumber && 'clear',
                                    onClickRightIcon: _cache[6] || (_cache[6] = 
                            () => {
                              _ctx.data.FormData.phoneNumber = '';
                            }
                          )
                                  }, null, 8, ["placeholder", "modelValue", "right-icon"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.forms.bankCode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t("cashier.bank")), 1),
                                _createElementVNode("div", _hoisted_66, [
                                  _createVNode(_component_van_cell, {
                                    "is-link": "",
                                    icon: "wap-home-o",
                                    title: _ctx.getNameByCode(_ctx.data.FormData.bankCode, _ctx.BankList) || _ctx.$t('choose'),
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showBankSheet = true))
                                  }, null, 8, ["title"]),
                                  false
                                    ? (_openBlock(), _createBlock(_component_van_action_sheet, {
                                        key: 0,
                                        show: _ctx.showBankSheet,
                                        "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (_ctx.showBankSheet = $event)),
                                        actions: _ctx.BankList,
                                        onSelect: _ctx.onSelectBank,
                                        description: _ctx.$t('choose'),
                                        "cancel-text": _ctx.$t('cancel'),
                                        "close-on-click-action": ""
                                      }, null, 8, ["show", "actions", "onSelect", "description", "cancel-text"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_van_action_sheet, {
                                    show: _ctx.showBankSheet,
                                    "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => (_ctx.showBankSheet = $event)),
                                    description: _ctx.$t('choose'),
                                    "cancel-text": _ctx.$t('cancel'),
                                    "close-on-click-action": "",
                                    class: "bank-select"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_67, [
                                        _createElementVNode("div", _hoisted_68, [
                                          _createVNode(_component_van_field, {
                                            label: ``,
                                            placeholder: "Search",
                                            modelValue: _ctx.data.Search.bank,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.data.Search.bank = $event)),
                                            "left-icon": "search",
                                            "right-icon": _ctx.data.Search.bank && 'clear',
                                            onClickRightIcon: _cache[10] || (_cache[10] = 
                                  () => {
                                    _ctx.data.Search.bank = '';
                                  }
                                )
                                          }, null, 8, ["modelValue", "right-icon"])
                                        ])
                                      ]),
                                      _createElementVNode("ul", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.BankList, (item) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: item.value,
                                            onClick: ($event: any) => (_ctx.onSelectBank(item))
                                          }, _toDisplayString(item.name), 9, _hoisted_69))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["show", "description", "cancel-text"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.forms.bankNumber)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.$t("cashier.bankNumber")), 1),
                                _createElementVNode("div", _hoisted_72, [
                                  _createVNode(_component_van_field, {
                                    label: ``,
                                    modelValue: _ctx.data.FormData.bankNumber,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.data.FormData.bankNumber = $event)),
                                    placeholder: _ctx.$t('cashier.bankNumber'),
                                    "left-icon": "coupon-o",
                                    "right-icon": _ctx.data.FormData.bankNumber && 'clear',
                                    onClickRightIcon: _cache[13] || (_cache[13] = 
                            () => {
                              _ctx.data.FormData.bankNumber = '';
                            }
                          )
                                  }, null, 8, ["modelValue", "placeholder", "right-icon"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.forms.accountName)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.$t("cashier.accountName")), 1),
                                _createElementVNode("div", _hoisted_75, [
                                  _createVNode(_component_van_field, {
                                    modelValue: _ctx.data.FormData.accountName,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.data.FormData.accountName = $event)),
                                    "left-icon": "user-o",
                                    "right-icon": 
                            _ctx.data.FormData.accountName &&
                              _ctx.data.FormData.channelCode == 'AlchemyPay' &&
                              'clear'
                          ,
                                    onClickRightIcon: _cache[15] || (_cache[15] = 
                            () => {
                              _ctx.data.FormData.accountName = '';
                            }
                          ),
                                    placeholder: _ctx.$t('cashier.accountName'),
                                    disabled: _ctx.data.FormData.channelCode == 'AlchemyPay' ? false : true,
                                    label: ``
                                  }, null, 8, ["modelValue", "right-icon", "placeholder", "disabled"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      (!_ctx.result)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "btn cancel",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.nextStep(false)))
                          }, _toDisplayString(_ctx.$t("cashier.back")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.result && _ctx.data.FormData.cancelUrl)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "btn cancel",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.paymentUrl(_ctx.data.FormData.cancelUrl, 'CANCEL')))
                          }, _toDisplayString(_ctx.$t("cashier.cancel")), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.result)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["btn next", { disabled: _ctx.isDisableConfirm }]),
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.nextStep(true)))
                          }, _toDisplayString(_ctx.step == _ctx.steps.length ? _ctx.$t("cashier.pay") : _ctx.$t("cashier.next")), 3))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ], 2))
          : _createCommentVNode("", true),
        ([1, 2, 3, 4, 5, 6, 7, 8].includes(_ctx.data.FormData.orderStatus))
          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
              ([0, 1, 2, 3, 4].includes(_ctx.data.FormData.orderStatus))
                ? (_openBlock(), _createElementBlock("div", _hoisted_79))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("img", {
                  src: `/images/status/${_ctx.CashPayOutOrderStatus[_ctx.data.FormData.orderStatus]}.png`,
                  alt: _ctx.CashPayOutOrderStatus[_ctx.data.FormData.orderStatus]
                }, null, 8, _hoisted_81)
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createTextVNode(_toDisplayString(_ctx.$t(`cashier.PayoutStatus[${_ctx.data.FormData.orderStatus}]`)) + " ", 1),
                _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.data.FormData.currency) + " " + _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.$t("cashier.orderNo")), 1),
                    _createElementVNode("div", _hoisted_86, [
                      _createTextVNode(_toDisplayString(_ctx.data.FormData.outOrderNo) + " ", 1),
                      _createElementVNode("span", {
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.copy(_ctx.data.FormData.outOrderNo)))
                      }, _hoisted_88)
                    ])
                  ]),
                  false
                    ? (_openBlock(), _createElementBlock("li", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.$t("cashier.channel")), 1),
                        _createElementVNode("div", _hoisted_91, [
                          (_ctx.data.FormData.channelIcon)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                _createElementVNode("img", {
                                  src: _ctx.data.FormData.channelIcon,
                                  alt: _ctx.data.FormData.channelName
                                }, null, 8, _hoisted_93)
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.data.FormData.channelName || "--"), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.accountType)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_94, [
                        _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.$t("cashier.paymentType")), 1),
                        _createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.data.FormData.accountType), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.paymentCode)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.$t("cashier.paymentCode")), 1),
                        _createElementVNode("div", _hoisted_99, [
                          _createTextVNode(_toDisplayString(_ctx.data.FormData.paymentCode) + " ", 1),
                          _createElementVNode("span", {
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.copy(_ctx.data.FormData.paymentCode)))
                          }, _hoisted_101)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.qrCode || _ctx.data.FormData.paymentCode)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_102, [
                        _createElementVNode("div", _hoisted_103, [
                          _createVNode(_component_VueQrcode, {
                            value: 
                        _ctx.data.FormData.accountType == 'QRIS'
                          ? _ctx.data.FormData.qrCode
                          : _ctx.data.FormData.paymentCode
                      ,
                            tag: "img",
                            options: {
                        width: 140,
                        margin: 0
                      }
                          }, null, 8, ["value"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createElementBlock("li", _hoisted_104))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createElementBlock("li", _hoisted_105, [
                        _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.$t("cashier.fee")), 1),
                        _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.data.FormData.serviceFee) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_108, [
                    _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.$t("cashier.orderTime")), 1),
                    _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.FormatDateZone(_ctx.data.FormData.creationAt) || "--"), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_111, [
      (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
        ? (_openBlock(), _createBlock(_component_i18n_t, {
            key: 0,
            keypath: "cashier.copyright",
            scope: "global"
          }, {
            mail: _withCtx(() => [
              _hoisted_112
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
      ? (_openBlock(), _createElementBlock("div", _hoisted_113, _hoisted_115))
      : _createCommentVNode("", true)
  ]))
}